import { composeInitialState } from '@opengov/compose-app';
import { Map } from 'immutable';

import { composeStateMachine } from '../module';

export enum FeatureFlagStatus {
  Loading = 'loading',
  Current = 'current'
}

export type FlagValue = boolean | string | number;
export interface IFlagChangeValue {
  current: FlagValue;
}

export const LaunchDarklyInitialState = composeInitialState({
  flags: Map<string, FlagValue>(),
  featureFlagStatus: FeatureFlagStatus.Loading
});

export const launchDarklyState = composeStateMachine('launch-darkly', LaunchDarklyInitialState, (compose) => ({
  receivedAllFlags: compose.action((state, flags: { [k: string]: FlagValue }) => {
    return state.set('flags', Map(flags));
  }),

  receivedVariation: compose.action((state, params: { key: string; value: any }) => {
    return state.update('flags', (flags) => flags.set(params.key, params.value));
  }),

  receivedChangeNotification: compose.action((state, flags: { [k: string]: IFlagChangeValue | FlagValue }) => {
    const reshapedFlags = Object.entries(flags).reduce<{ [k: string]: FlagValue }>((prev, [key, value]) => {
      // Only reshape if we see unexpected values in the flags
      if (typeof value !== 'boolean' && typeof value !== 'string' && typeof value !== 'number') {
        prev[key] = value?.current;
      } else {
        prev[key] = value;
      }
      return prev;
    }, {});
    return state.update('flags', (currentFlags) => {
      return currentFlags.merge(Map(reshapedFlags));
    });
  }),

  setFeatureFlagStatus: compose.action((state, status) => state.set('featureFlagStatus', status))
}));

export const {
  actions: launchDarklyActions,
  actionCreators: launchDarklyActionCreators,
  reducer: launchDarklyReducer,
  selector: launchDarklySelector
} = launchDarklyState;
